// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"db10de6f","132":"44f25de6","808":"71323ed6","952":"455ac51c","982":"055fc64f"}[chunkId] + ".chunk.css";
};